export default __webpack_public_path__ + "static/media/DefaultBell.3acae7ae.svg";